<template>
    <div>
        <h1>Organisms</h1>
        <ds-organisms-list />
    </div>
</template>
